import React from 'react';
import { Carousel as AntdCarousel } from 'antd';

const Carousel = React.forwardRef<any, React.ComponentProps<typeof AntdCarousel>>((props, ref) => {
  return <AntdCarousel ref={ref} {...props} />;
});

Carousel.displayName = 'Carousel';

export default Carousel;